export default __webpack_public_path__ + "static/media/bg_banner_servicios02.de0d0059.png";